<template>
  <button
    class="
      flex
      items-center
      justify-center
      p-2
      font-medium
      text-base
      whitespace-nowrap
      text-white
      bg-green-600
      hover:bg-green-700
      disabled:bg-gray-400
      rounded-sm
      shadow
    "
  >
    <slot />
  </button>
</template>
